<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
    :rules="validationRules"
  >
    <div
      class="mb-4"
      :class="{'validation-failed':failed}"
    >
      <item-name :item="item" />
      <input
        v-model="value"
        type="number"
        class="px-4 py-4 bg-gray-800 text-gray-100 w-full border-3 border-transparent appearance-none outline-none focus:border-orange-700"
      >
      <item-errors :errors="errors" />
    </div>
  </validation-provider>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemName,
    ItemErrors
  },
  mixins: [ItemMixin]
}
</script>

<style scoped>
  /*
  Hide number stepper
   */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
